import {axiosi} from '../../config/axios'
import { getFirestore, collection, query, where, getDocs , getDoc ,serverTimestamp , addDoc , doc, deleteDoc, updateDoc  } from "firebase/firestore";


// export const createWishlistItem=async(data)=>{
//     try {
//         const res=await axiosi.post("/wishlist",data)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }

export const createWishlistItem = async (item) => {
  try {
    const db = getFirestore();
    console.log("create wishlist", item);
    // 1. Check if wishlist item already exists
    const q = query(
      collection(db, "wishlist"),
      where("user", "==", item.user),
      where("product", "==", item.product) // product = productId
    );

    const snap = await getDocs(q);

    if (!snap.empty) {
      const existing = snap.docs[0];
      return {
        _id: existing.id,
        ...existing.data(),
      };
    }

    // 2. PRODUCT FETCH
    const productRef = doc(db, "products", item.product);
    const productSnap = await getDoc(productRef);

    if (!productSnap.exists()) {
      throw new Error("Product not found!");
    }

    const product = { _id: productSnap.id, ...productSnap.data() };

    // 3. BRAND FETCH (if exists)
    let brand = null;

    if (product.brand) {
      const brandRef = doc(db, "brands", product.brand);
      const brandSnap = await getDoc(brandRef);

      if (brandSnap.exists()) {
        brand = { _id: brandSnap.id, ...brandSnap.data() };
      }
    }

    // 4. Create nested product → brand structure
    const payload = {
      user: item.user,
      product: {
        ...product,
        brand: brand || null,
      },
      size: item.size,
      color: item.color,
      productId: item.product, // keep raw product id also
      // note:"anything",
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    };

    const docRef = await addDoc(collection(db, "wishlist"), payload);

    // 5. Return final structure
    return {
      _id: docRef.id,
      ...payload,
    };

  } catch (error) {
    console.error("Error creating wishlist item:", error);
    throw { message: "Failed to create wishlist item", error };
  }
};


// export const fetchWishlistByUserId=async(id)=>{
//     try {
//         const res=await axiosi.get(`/wishlist/users/${id}`)
//         const totalResults=await res.headers.get("X-Total-Count")
//         // return {data:res.data,totalResults:totalResults}
//     } catch (error) {
//         // throw error.response.data
//         return {
//             data:[
//                 {
//                     "_id": "65c2441232078478e340ab60",
//                     "user": "65b8e564ea5ce114184ccb96",
//                     "product": {
//                         "_id": "65a7e45902e12c44f599444e",
//                         "title": "iPhone 9",
//                         "description": "An apple mobile which is nothing like apple",
//                         "price": 549,
//                         "discountPercentage": 12.96,
//                         "category": "65a7e24602e12c44f599442c",
//                         "brand": {
//                             "_id": "65a7e20102e12c44f59943da",
//                             "name": "Apple",
//                             "__v": 0
//                         },
//                         "stockQuantity": 14,
//                         "thumbnail": "https://cdn.dummyjson.com/product-images/1/thumbnail.jpg",
//                         "images": [
//                             "https://cdn.dummyjson.com/product-images/1/1.jpg",
//                             "https://cdn.dummyjson.com/product-images/1/2.jpg",
//                             "https://cdn.dummyjson.com/product-images/1/3.jpg",
//                             "https://cdn.dummyjson.com/product-images/1/4.jpg",
//                             "https://cdn.dummyjson.com/product-images/1/thumbnail.jpg"
//                         ],
//                         "isDeleted": false,
//                         "updatedAt": "2024-02-07T09:22:57.840Z",
//                         "createdAt": "2025-11-29T16:22:52.593Z"
//                     },
//                     "note": "Can't. Stop. Thinking. About. This. Phone.  All the new features are giving me major FOMO. Next paycheck, consider yourself spent! **",
//                     "createdAt": "2024-02-07T10:11:46.794Z",
//                     "updatedAt": "2024-02-07T10:11:46.794Z"
//                 },
//                 {
//                     "_id": "65c2441732078478e340ab6c",
//                     "user": "65b8e564ea5ce114184ccb96",
//                     "product": {
//                         "_id": "65a7e45902e12c44f5994456",
//                         "title": "Infinix INBOOK",
//                         "description": "Infinix Inbook X1 Ci3 10th 8GB 256GB 14 Win10 Grey – 1 Year Warranty",
//                         "price": 1099,
//                         "discountPercentage": 11.83,
//                         "category": "65a7e24602e12c44f599442d",
//                         "brand": {
//                             "_id": "65a7e20102e12c44f59943df",
//                             "name": "Infinix",
//                             "__v": 0
//                         },
//                         "stockQuantity": 96,
//                         "thumbnail": "https://cdn.dummyjson.com/product-images/9/thumbnail.jpg",
//                         "images": [
//                             "https://cdn.dummyjson.com/product-images/9/1.jpg",
//                             "https://cdn.dummyjson.com/product-images/9/2.png",
//                             "https://cdn.dummyjson.com/product-images/9/3.png",
//                             "https://cdn.dummyjson.com/product-images/9/4.jpg",
//                             "https://cdn.dummyjson.com/product-images/9/thumbnail.jpg"
//                         ],
//                         "isDeleted": false,
//                         "updatedAt": "2024-02-07T09:22:57.840Z",
//                         "createdAt": "2025-11-29T16:22:52.595Z"
//                     },
//                     "note": "Gaming beast unlocked! This laptop with its latest features like dedicated graphics card, fast refresh rate, powerful cooling system] would be the ultimate gaming machine. Time to conquer those virtual worlds! ⚔️",
//                     "createdAt": "2024-02-07T10:11:46.794Z",
//                     "updatedAt": "2024-02-07T10:11:46.794Z"
//                 },
//                 {
//                     "_id": "65c2441a32078478e340ab70",
//                     "user": "65b8e564ea5ce114184ccb96",
//                     "product": {
//                         "_id": "65a7e45902e12c44f5994452",
//                         "title": "Huawei P30",
//                         "description": "Huawei’s re-badged P30 Pro New Edition was officially unveiled yesterday in Germany and now the device has made its way to the UK.",
//                         "price": 499,
//                         "discountPercentage": 10.58,
//                         "category": "65a7e24602e12c44f599442c",
//                         "brand": {
//                             "_id": "65a7e20102e12c44f59943dd",
//                             "name": "Huawei",
//                             "__v": 0
//                         },
//                         "stockQuantity": 32,
//                         "thumbnail": "https://cdn.dummyjson.com/product-images/5/thumbnail.jpg",
//                         "images": [
//                             "https://cdn.dummyjson.com/product-images/5/1.jpg",
//                             "https://cdn.dummyjson.com/product-images/5/2.jpg",
//                             "https://cdn.dummyjson.com/product-images/5/3.jpg"
//                         ],
//                         "isDeleted": false,
//                         "updatedAt": "2024-02-07T09:22:57.840Z",
//                         "createdAt": "2025-11-29T16:22:52.594Z"
//                     },
//                     "note": "Have to buy this for my friend's birthday",
//                     "createdAt": "2024-02-07T10:11:46.794Z",
//                     "updatedAt": "2024-02-07T10:11:46.794Z"
//                 },
//                 {
//                     "_id": "65c2442132078478e340ab7a",
//                     "user": "65b8e564ea5ce114184ccb96",
//                     "product": {
//                         "_id": "65a7e45902e12c44f59944b0",
//                         "title": "American Vintage Wood Pendant Light",
//                         "description": "American Vintage Wood Pendant Light Farmhouse Antique Hanging Lamp Lampara Colgante",
//                         "price": 46,
//                         "discountPercentage": 8.84,
//                         "category": "65a7e24602e12c44f599443f",
//                         "brand": {
//                             "_id": "65a7e20102e12c44f5994425",
//                             "name": "Ifei Home",
//                             "__v": 0
//                         },
//                         "stockQuantity": 138,
//                         "thumbnail": "https://cdn.dummyjson.com/product-images/99/thumbnail.jpg",
//                         "images": [
//                             "https://cdn.dummyjson.com/product-images/99/1.jpg",
//                             "https://cdn.dummyjson.com/product-images/99/2.jpg",
//                             "https://cdn.dummyjson.com/product-images/99/3.jpg",
//                             "https://cdn.dummyjson.com/product-images/99/4.jpg",
//                             "https://cdn.dummyjson.com/product-images/99/thumbnail.jpg"
//                         ],
//                         "isDeleted": false,
//                         "updatedAt": "2024-02-07T09:22:57.840Z",
//                         "createdAt": "2025-11-29T16:22:52.604Z"
//                     },
//                     "note": "Mood magic! These smart lights would transform my living room into the perfect movie night haven with customisable colours and dimming. Goodbye, harsh overhead lights! ✨",
//                     "createdAt": "2024-02-07T10:11:46.794Z",
//                     "updatedAt": "2024-02-07T10:11:46.794Z"
//                 },
//                 {
//                     "_id": "65c2443632078478e340ab9a",
//                     "user": "65b8e564ea5ce114184ccb96",
//                     "product": {
//                         "_id": "65a7e45902e12c44f5994474",
//                         "title": "Women Sweaters Wool",
//                         "description": "2021 Custom Winter Fall Zebra Knit Crop Top Women Sweaters Wool Mohair Cos Customize Crew Neck Women' S Crop Top Sweater",
//                         "price": 600,
//                         "discountPercentage": 17.2,
//                         "category": "65a7e24602e12c44f5994433",
//                         "brand": {
//                             "_id": "65a7e20102e12c44f59943fc",
//                             "name": "Top Sweater",
//                             "__v": 0
//                         },
//                         "stockQuantity": 55,
//                         "thumbnail": "https://cdn.dummyjson.com/product-images/39/thumbnail.jpg",
//                         "images": [
//                             "https://cdn.dummyjson.com/product-images/39/1.jpg",
//                             "https://cdn.dummyjson.com/product-images/39/2.jpg",
//                             "https://cdn.dummyjson.com/product-images/39/3.jpg",
//                             "https://cdn.dummyjson.com/product-images/39/4.jpg",
//                             "https://cdn.dummyjson.com/product-images/39/thumbnail.jpg"
//                         ],
//                         "isDeleted": false,
//                         "updatedAt": "2024-02-07T09:22:57.840Z",
//                         "createdAt": "2025-11-29T16:22:52.597Z"
//                     },
//                     "note": "A perfect christmas gift for my wife",
//                     "createdAt": "2024-02-07T10:11:46.794Z",
//                     "updatedAt": "2024-02-07T10:11:46.794Z"
//                 },
//                 {
//                     "_id": "65c2444732078478e340aba4",
//                     "user": "65b8e564ea5ce114184ccb96",
//                     "product": {
//                         "_id": "65a7e45902e12c44f5994481",
//                         "title": "FREE FIRE T Shirt",
//                         "description": "quality and professional print - It doesn't just look high quality, it is high quality.",
//                         "price": 10,
//                         "discountPercentage": 14.72,
//                         "category": "65a7e24602e12c44f5994436",
//                         "brand": {
//                             "_id": "65a7e20102e12c44f5994407",
//                             "name": "FREE FIRE",
//                             "__v": 0
//                         },
//                         "stockQuantity": 128,
//                         "thumbnail": "https://cdn.dummyjson.com/product-images/52/thumbnail.jpg",
//                         "images": [
//                             "https://cdn.dummyjson.com/product-images/52/1.png",
//                             "https://cdn.dummyjson.com/product-images/52/2.png",
//                             "https://cdn.dummyjson.com/product-images/52/3.jpg",
//                             "https://cdn.dummyjson.com/product-images/52/4.jpg",
//                             "https://cdn.dummyjson.com/product-images/52/thumbnail.jpg"
//                         ],
//                         "isDeleted": false,
//                         "updatedAt": "2024-02-07T09:22:57.840Z",
//                         "createdAt": "2025-11-29T16:22:52.598Z"
//                     },
//                     "note": "A perfect gift for my relative's kid",
//                     "createdAt": "2024-02-07T10:11:46.794Z",
//                     "updatedAt": "2024-02-07T10:11:46.794Z"
//                 },
//                 {
//                     "_id": "65c2445332078478e340abab",
//                     "user": "65b8e564ea5ce114184ccb96",
//                     "product": {
//                         "_id": "65a7e45902e12c44f599448a",
//                         "title": "Leather Straps Wristwatch",
//                         "description": "Style:Sport ,Clasp:Buckles ,Water Resistance Depth:3Bar",
//                         "price": 120,
//                         "discountPercentage": 7.14,
//                         "category": "65a7e24602e12c44f5994438",
//                         "brand": {
//                             "_id": "65a7e20102e12c44f599440b",
//                             "name": "Naviforce",
//                             "__v": 0
//                         },
//                         "stockQuantity": 91,
//                         "thumbnail": "https://cdn.dummyjson.com/product-images/61/thumbnail.jpg",
//                         "images": [
//                             "https://cdn.dummyjson.com/product-images/61/1.jpg",
//                             "https://cdn.dummyjson.com/product-images/61/2.png",
//                             "https://cdn.dummyjson.com/product-images/61/3.jpg"
//                         ],
//                         "isDeleted": false,
//                         "updatedAt": "2024-02-07T09:22:57.840Z",
//                         "createdAt": "2025-11-29T16:22:52.600Z"
//                     },
//                     "note": "A nice decent watch like this would be a perfect match with my outfit this saturday night",
//                     "createdAt": "2024-02-07T10:11:46.794Z",
//                     "updatedAt": "2024-02-07T10:11:46.794Z"
//                 },
//                 {
//                     "_id": "65c2447032078478e340abd4",
//                     "user": "65b8e564ea5ce114184ccb96",
//                     "product": {
//                         "_id": "65a7e45902e12c44f59944a2",
//                         "title": "LouisWill Men Sunglasses",
//                         "description": "LouisWill Men Sunglasses Polarized Sunglasses UV400 Sunglasses Day Night Dual Use Safety Driving Night Vision Eyewear AL-MG Frame Sun Glasses with Free Box for Drivers",
//                         "price": 50,
//                         "discountPercentage": 11.27,
//                         "category": "65a7e24602e12c44f599443c",
//                         "brand": {
//                             "_id": "65a7e20102e12c44f5994413",
//                             "name": "LouisWill",
//                             "__v": 0
//                         },
//                         "stockQuantity": 92,
//                         "thumbnail": "https://cdn.dummyjson.com/product-images/85/thumbnail.jpg",
//                         "images": [
//                             "https://cdn.dummyjson.com/product-images/85/1.jpg",
//                             "https://cdn.dummyjson.com/product-images/85/2.jpg",
//                             "https://cdn.dummyjson.com/product-images/85/thumbnail.jpg"
//                         ],
//                         "isDeleted": false,
//                         "updatedAt": "2024-02-07T09:22:57.840Z",
//                         "createdAt": "2025-11-29T16:22:52.602Z"
//                     },
//                     "note": "Have to buy this for upcoming beach party",
//                     "createdAt": "2024-02-07T10:11:46.794Z",
//                     "updatedAt": "2024-02-07T10:11:46.794Z"
//                 }
//             ]
//             ,
//             totalResults:8}
//     }
// }

// export const fetchWishlistByUserId = async (id) => {
//     try {
//       const db = getFirestore();
  
//       // Query wishlist items by user ID
//       const q = query(collection(db, "wishlist"), where("user", "==", id));
//       const snap = await getDocs(q);
  
//       // Convert documents into array
//       const data = snap.docs.map((doc) => ({
//         _id: doc.id,
//         ...doc.data(),
//       }));
  
//       return {
//         data,
//         totalResults: data.length,
//       };
  
//     } catch (error) {
//       console.error("Error fetching wishlist:", error);
  
//       // fallback demo data
//       return {
//         data: [ /* your fallback objects */ ],
//         totalResults: 8
//       };
//     }
//   };
  

  export const fetchWishlistByUserId = async (userId) => {
    try {
      const db = getFirestore();
  
      // 1. Fetch wishlist items by user ID
      const q = query(collection(db, "wishlist"), where("user", "==", userId));
      const snap = await getDocs(q);
  
      const result = [];
  
      for (let wishDoc of snap.docs) {
        const wishData = wishDoc.data();
  
        // 2. Fetch product
        const productRef = doc(db, "products", wishData.productId);
        const productSnap = await getDoc(productRef);
  
        let product = null;
        let brand = null;
  
        if (productSnap.exists()) {
          product = { _id: productSnap.id, ...productSnap.data() };
  
          // 3. Fetch brand if exists
          if (product.brand) {
            const brandRef = doc(db, "brands", product.brand);
            const brandSnap = await getDoc(brandRef);
  
            if (brandSnap.exists()) {
              brand = { _id: brandSnap.id, ...brandSnap.data() };
            }
          }
        }
        // console.log('wishlist', wishData.note);
        // 4. Final structured response
        result.push({
          _id: wishDoc.id,
          note: wishData.note,
          user: userId,
          product: product
            ? { ...product, brand: brand || null }
            : null,
            size: wishData.size,
            color: wishData.color,  
          createdAt: wishData.createdAt || null
        });
      }
  
      return {
        data: result,
        totalResults: result.length,
      };
  
    } catch (error) {
      console.error("Error fetching wishlist:", error);
      return { data: [], totalResults: 0 };
    }
  };

// export const updateWishlistItemById=async(update)=>{
//     try {
//         const res=await axiosi.patch(`/wishlist/${update._id}`,update)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }

export const updateWishlistItemById = async (update) => {
    try {
      const db = getFirestore();
  
      const ref = doc(db, "wishlist", update._id);
  
      const result = await updateDoc(ref, update);
      // console.log('update wishlist',update);
      return {
        message: "Wishlist item updated successfully",
        // _id: update._id,
        ...update
      };
  
    } catch (error) {
      console.error("Error updating wishlist item:", error);
      throw { message: "Failed to update wishlist item", error };
    }
  };
  

// export const deleteWishlistItemById=async(id)=>{
//     try {
//         const res=await axiosi.delete(`/wishlist/${id}`)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }

export const deleteWishlistItemById = async (id) => {
  try {
    const db = getFirestore();

    // Document reference
    const ref = doc(db, "wishlist", id);

    // Delete from Firestore
    await deleteDoc(ref);

    return {
      message: "Wishlist item deleted successfully",
      _id: id,
    };

  } catch (error) {
    console.error("Error deleting wishlist item:", error);
    throw { message: "Failed to delete wishlist item", error };
  }
};
  